import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as jobService from '../../../services/job/index';
import { toast } from "react-toastify";

export const createJob = createAsyncThunk(
    'job/createJob',
    async (payload, thunkAPI) => {
        try {
            const result = await jobService.createJob(payload);
            if (result?.success) {
                toast.success(result?.message || "Job successfully created");
                return result?.data || [];
            } else {
                toast.error("Job is already mapped with provided account");
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.error("Error in createJob:", err);
            const message =
                err?.response?.data?.message ||
                err?.response?.data ||
                err?.message;

            // toast.error(message);
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const updateJob = createAsyncThunk(
    'job/updateJob',
    async (payload, thunkAPI) => {
        try {
            const result = await jobService.updateJob(payload);
            if (result?.success) {
                toast.success(result?.message || "Job successfully updated");
                return result?.data || [];
            } else {
                console.log("lksdajfasdksdf result : ", result);
                toast.error(result?.message || "Error in updating Job!");
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in createJob : ", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error!");
        }
    }
)

export const deleteJob = createAsyncThunk(
    'job/deleteJob',
    async (payload, thunkAPI) => {
        try {
            const result = await jobService.deleteJob(payload);
            if (result?.success) {
                toast.success(result?.message || "Job successfully deleted");
                return result?.data || [];
            } else {
                toast.error(result?.message || "Error in deleting Job!");
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in createJob : ", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error!");
        }
    }
)

export const fetchJobs = createAsyncThunk(
    'job/fetchJobs',
    async (payload, thunkAPI) => {
        try {
            const result = await jobService.fetchJobs(payload);
            if (result?.success) {
                return result?.data || [];
            } else {
                toast.error(result?.message || "Error in deleting Job!");
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in createJob : ", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error!");
        }
    }
)


const initialState = {
    jobs: {
        data: [],
        pagination: {
            total: 0,
            page: 1,
            limit: 10,
            totalPages: 0,
        },
        loading: false,
        error: null,
    },
};

const jobSlice = createSlice({
    initialState,
    name: 'job',
    reducers: {},
    extraReducers: (builder) => {
        //fetchJobs
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.jobs.loading = true;
                state.jobs.error = null;
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.jobs.loading = false;
                state.jobs.data = action.payload?.jobs || [];
                state.jobs.pagination = action.payload?.pagination || {
                    total: 0,
                    page: 1,
                    limit: 10,
                    totalPages: 0,
                };
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.jobs.loading = false;
                state.jobs.error = action.payload || "Failed to fetch jobs.";
            });
    }
})

export const jobReducer = jobSlice.reducer;